// ProjectsSection.jsx
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Slider from './Slider';
import { fetchProjects } from '../data/projectSlice';
import { useBackendTranslation } from '../utils/useBackendTranslation';

const ProjectsSection = () => {
  const dispatch = useDispatch();
  const { project, title, status } = useSelector(state => state.project);
  
  // Use our custom hook to translate backend data
  const { translatedData: translatedProjects } = useBackendTranslation(project, { skipFields: ['image', 'id'] });
  const { translatedData: translatedTitle } = useBackendTranslation(title);
  
  // Fetch projects on component mount
  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchProjects());
    }
  }, [dispatch, status]);

  return (
    <div className="w-full">
      {/* Loading State */}
      {status === 'loading' || !translatedProjects || translatedProjects.length === 0 ? (
        <div className="text-center py-12">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-300 rounded-md w-3/4 mx-auto mb-4"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map((item) => (
                <div key={item} className="bg-gray-300 h-64 rounded-lg"></div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="projects-section">
          <Slider 
            data={translatedProjects} 
            title={translatedTitle || "Our Projects"} 
            className="projects-slider"
          />
        </div>
      )}
    </div>
  );
};

export default ProjectsSection;